import { render, staticRenderFns } from "./projectsGrid.vue.html?vue&type=template&id=00b5a425&"
import script from "./projectsGrid.ts?vue&type=script&lang=ts&"
export * from "./projectsGrid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports